import React from 'react';
import { Box, Container, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { ITalentReview, IWorkProfile } from '../../../types/global/helper';
import { WorkProfileWrapper, IWorkProfileProps as ProfileInterface } from '../../WorkProfile/WorkProfileWrapper';
import { CommentOutlined, ContactMailOutlined, MoreVert, StarBorder } from '@mui/icons-material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { IApplication } from '../../../types/global/ListRender.types';

export interface IWorkProfileProps extends Omit<ProfileInterface, 'workProfile'> {
    workProfile: IWorkProfile[] | null;
    reviews?: ITalentReview[];
    loadingReview?: boolean;
    page?: number;
    external?: boolean;
    applicationData?: IApplication;
    onAcceptApplication?: () => void;
    onRejectApplication?: () => void;
    onMessageApplication?: () => void;
    onInviteClick?: VoidFunction;
    onMessageClick?: VoidFunction;
    onRateClick?: VoidFunction;
    userName?: string;
}

const DISABLE_FAB = true;

const WorkProfile: React.FC<IWorkProfileProps> = ({
    workProfile,
    external,
    applicationData,
    onAcceptApplication,
    onRejectApplication,
    onMessageApplication,
    onInviteClick,
    onMessageClick,
    onRateClick,
    userName,
    ...props
}) => {
    const { themeStyle, device } = useThemeContext();
    const actions = [
        { icon: <ContactMailOutlined />, name: 'Invite to Apply' },
        { icon: <CommentOutlined />, name: 'Message' },
        { icon: <StarBorder />, name: 'Rate Talent' },
    ];

    const handleActionClick = (type: string) => {
        switch (type) {
            case 'Invite to Apply':
                onMessageApplication && onMessageApplication();
                break;
            case 'Message':
                onMessageApplication && onMessageApplication();
                break;
            case 'Rate Talent':
                onRateClick && onRateClick();
                break;
        }
    };
    return (
        <Container
            disableGutters={device.isMobile}
            sx={{
                overflow: 'auto',
                height: 'auto',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                ml: { xs: 0, sm: 10 },
                width: { xs: '100%', sm: '85%', smMd: '90%', xl: '95%' },
            }}
            maxWidth={false}>
            {workProfile && (
                <WorkProfileWrapper
                    external={external}
                    workProfile={workProfile}
                    applicationData={applicationData}
                    onAcceptApplication={onAcceptApplication}
                    onRejectApplication={onRejectApplication}
                    onMessageApplication={onMessageApplication}
                    userName={userName}
                    {...props}
                />
            )}
            {/* Floating Action Button (FAB) */}
            {!props.isPreviewMode && external && !DISABLE_FAB && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 20,
                        right: 20,
                        zIndex: 1000,
                    }}>
                    <SpeedDial
                        ariaLabel="Casting Actions"
                        icon={<SpeedDialIcon openIcon={<MoreVert />} />}
                        direction="up"
                        sx={{
                            '& .MuiFab-primary': {
                                backgroundColor: theme[themeStyle].tag_white,
                                color: theme[themeStyle].deep_grey,
                                '&:hover': {
                                    color: theme[themeStyle].deep_grey,
                                },
                            },
                        }}>
                        {actions.map(action => (
                            <SpeedDialAction
                                key={action.name}
                                icon={action.icon}
                                onClick={() => handleActionClick(action.name)}
                                tooltipTitle={action.name}
                                sx={{
                                    backgroundColor: '#fff',
                                    '&:hover': { backgroundColor: '#eee' },
                                }}
                            />
                        ))}
                    </SpeedDial>
                </Box>
            )}
        </Container>
    );
};

export { WorkProfile };
